var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickLinksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 21.6469L18.1562 16.5L13 11.3531V13.875C13 14.4984 12.4984 15 11.875 15H6.25V18H11.875C12.4984 18 13 18.5016 13 19.125V21.6469ZM20.5 16.5C20.5 17.0391 20.2844 17.5547 19.9047 17.9344L14.4625 23.3625C14.0547 23.7703 13.5016 24 12.925 24C11.725 24 10.75 23.025 10.75 21.825V20.25H6.25C5.00781 20.25 4 19.2422 4 18V15C4 13.7578 5.00781 12.75 6.25 12.75H10.75V11.175C10.75 9.975 11.725 9 12.925 9C13.5016 9 14.0547 9.22969 14.4625 9.6375L19.9047 15.0656C20.2844 15.4453 20.5 15.9609 20.5 16.5ZM20.125 24.75H23.875C24.9109 24.75 25.75 23.9109 25.75 22.875V10.125C25.75 9.08906 24.9109 8.25 23.875 8.25H20.125C19.5016 8.25 19 7.74844 19 7.125C19 6.50156 19.5016 6 20.125 6H23.875C26.1531 6 28 7.84688 28 10.125V22.875C28 25.1531 26.1531 27 23.875 27H20.125C19.5016 27 19 26.4984 19 25.875C19 25.2516 19.5016 24.75 20.125 24.75Z",
    fill: "#0D2EA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickLinksIcon);
export default __webpack_public_path__ + "static/media/quickLinksIcon.5c9d4bf86de9ee18a9403e98258a4317.svg";
export { ForwardRef as ReactComponent };